import React, { useState } from "react";
import { Box, Typography, Button, TextField, CircularProgress, Alert } from '@mui/material';

const TerraformConfig = () => {
  const [variables, setVariables] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleDeploy = async () => {
    if (!variables.trim()) {
      setError("Please provide Terraform variables");
      return;
    }
    setError("");
    setLoading(true);

    try {
      
      const res = await fetch("/api/terraform/deploy", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ variables })
      });
      const data = await res.json();
      if (!data.success) throw new Error(data.error || "Something went wrong");
      alert("Terraform process triggered successfully!");
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Terraform Infrastructure Deployment
      </Typography>
      <TextField
        label="Terraform Variables"
        value={variables}
        onChange={(e) => setVariables(e.target.value)}
        multiline
        rows={4}
        fullWidth
        sx={{ my: 2 }}
        placeholder='{"region":"us-east-1","env":"staging"}'
      />
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Button
        variant="contained"
        disabled={loading}
        onClick={handleDeploy}
      >
        {loading ? <CircularProgress size={20} /> : "Deploy via Terraform"}
      </Button>
    </Box>
  );
};

export default TerraformConfig;
